import { render } from "./TheEditor.vue?vue&type=template&id=20135a50"
import script from "./TheEditor.vue?vue&type=script&lang=js"
export * from "./TheEditor.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__